<template>
  <div class="p-3 bg-white">
    <shared-transfers-history
      :transferLogs="transferLogs"
    ></shared-transfers-history>
  </div>
</template>

<script>
import SharedTransfersHistory from '@/views/Shared/Transfers/History'
import TransferLog from '@/models/TransferLog'

export default {
  name: 'Window.Transfers.History',
  components: {
    SharedTransfersHistory
  },
  data () {
    return {
      transferLogs: {}
    }
  },
  mounted () {
    this.loadTransferHistory()
  },
  methods: {
    async loadTransferHistory () {
      const response = await TransferLog.history()
      this.transferLogs = response.data.data
    }
  }
}
</script>

<style scoped>

</style>
